import React, { useEffect, useState } from "react";
import clsx from "clsx";

import arrow_down from "../../../images/arrow_down.svg";
import {
  isMenuDisabled,
  selectInstance,
} from "../../../business/helper/Singleton";

const List = ({ items, prefixKey, onHistoricItemClick, header, active }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isDisabled, setIsDisabled] = useState(isMenuDisabled.state);
  const [selected, setSelected] = useState(selectInstance.state);

  useEffect(() => {
    const event = () => setIsDisabled(isMenuDisabled.state);
    isMenuDisabled.subscribe(event);

    return () => {
      isMenuDisabled.unsubscribe(event);
    };
  }, []);

  useEffect(() => {
    const event = () => setSelected(selectInstance.state);
    selectInstance.subscribe(event);

    return () => {
      selectInstance.unsubscribe(event);
    };
  }, []);

  return (
    <div
      className={clsx("bg-white rounded-xl py-4 overflow-hidden mb-3", {
        "pb-0": !isOpen,
        "cursor-not-allowed": isDisabled,
      })}
    >
      <h5
        className="font-bold text-dark-blue-100 text-[14px] mb-4 px-4 flex justify-between cursor-pointer"
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
      >
        {header}
        <img
          src={arrow_down}
          alt="arrow"
          className={clsx("transition-all", { "rotate-180": isOpen })}
        />
      </h5>
      <ul className={clsx("list-disc", { "h-0": !isOpen })}>
        {items.map((histo, index) => (
          <li
            key={`${prefixKey}${index}`}
            className={clsx(
              "mb-1 py-2 px-6 text-[14px] text-dark-blue-100 hover:border-l-4 hover:border-l-[#2A354A] border-l-4 border-l-transparent cursor-pointer truncate  hover:bg-whitesmoke-600",
              {
                "!border-l-[#2A354A] !border-l-4 bg-blue-200 text-dark-blue-100":
                  active === histo.threadId && selected === histo.id,
                "!text-[#969696] !cursor-not-allowed": isDisabled,
              }
            )}
            {...(!isDisabled && {
              onClick: () => {
                onHistoricItemClick(histo);
                selectInstance.state = histo.id;
              },
            })}
            data-tooltip-id="tooltipHisto"
            data-tooltip-content={histo.name}
            data-tooltip-place="right-end"
            data-tooltip-float
            data-tooltip-delay-show="300"
          >
            <span dangerouslySetInnerHTML={{ __html: histo.name?.replace("<br />", "") }} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default List;
